<template>
  <div class="alerts-section">
    <div class="alert-container">
      <alert v-if="docsMissingAlerts.length > 0">
        <template slot="title">
          <b-link
            @click="$emit('input', 1)"
            class="text-danger"
            v-track-click
            id="invoices-alerts-docs-pending-mobile"
          >
            <b-icon-exclamation-triangle-fill class="icon-svg" />
            {{ $t('alerts.invoice.docsRequired') }}
            <b-icon-arrow-right-short
              class="d-block d-md-none right-arrow"
              font-scale="1.8"
            />
          </b-link>
        </template>
        <template slot="message">
          {{ $t('alerts.invoice.docsPending') }}
        </template>
        <template slot="cta">
          <b-button
            variant="alert"
            size="lg"
            @click="$emit('input', 1)"
            v-track-click
            id="invoices-alerts-docs-pending"
          >
            {{ $t('alerts.invoice.docsPendingCta') }}
          </b-button>
        </template>
      </alert>
      <alert v-if="esignAlerts.length > 0" :show-cta="showCta">
        <template slot="title">
          <router-link
            :to="{ name: showCta ? 'invoicesEsign' : null }"
            class="text-danger"
            v-track-click
            id="invoices-alerts-esign-mobile"
          >
            <b-icon-exclamation-triangle-fill class="icon-svg" />
            {{ $t('alerts.invoice.esignRequired') }}
            <b-icon-arrow-right-short
              class="d-block d-md-none right-arrow"
              font-scale="1.8"
            />
          </router-link>
        </template>
        <template slot="message">
          {{ $t('alerts.invoice.esignPending') }}
        </template>
        <template slot="cta">
          <b-button
            variant="alert"
            size="lg"
            :to="{ name: 'invoicesEsign' }"
            v-track-click
            id="invoices-alerts-esign"
          >
            {{ $t('alerts.invoice.esignPendingCta') }}
          </b-button>
        </template>
      </alert>
    </div>
  </div>
</template>
<script>
import Alert from '@/components/Alerts2/Alert'

export default {
  props: ['invoice', 'value', 'showCta'],
  computed: {
    docsMissingAlerts() {
      return this.invoice.customer_pending_task_flows.filter((task) => {
        return task.uid.indexOf('upload_') === 0 && task.status !== 'completed'
      })
    },
    esignAlerts() {
      return this.invoice.customer_pending_task_flows.filter((task) => {
        return (
          task.uid.indexOf('_signable_documents') > -1 &&
          task.status !== 'completed'
        )
      })
    }
  },
  components: {
    Alert
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';
.alert-container {
  .icon-svg {
    color: $dc-error-border-color;
  }
  .right-arrow {
    cursor: pointer;
    float: right;
  }
}
</style>
